"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RectF = void 0;
class RectF {
    top = 0;
    left = 0;
    bottom = 0;
    right = 0;
    constructor(...args) {
        switch (args.length) {
            case 4: {
                const [left, top, right, bottom] = args;
                if (arguments.length === 4) {
                    this.left = left;
                    this.top = top;
                    this.right = right;
                    this.bottom = bottom;
                }
            }
        }
    }
    static intersects(a, b) {
        if (a.contains(b.left, b.top))
            return true;
        else if (a.contains(b.left, b.bottom))
            return true;
        else if (a.contains(b.right, b.top))
            return true;
        else if (a.contains(b.right, b.bottom))
            return true;
        return false;
    }
    ;
    width() {
        return this.right - this.left;
    }
    ;
    height() {
        return this.bottom - this.top;
    }
    ;
    contains(x, y) {
        if (this.left < x && x < this.right)
            if (this.top < y && y < this.bottom)
                return true;
        return false;
    }
    ;
}
exports.RectF = RectF;
;
//# sourceMappingURL=RectF.js.map